export default {"src":"/_next/static/media/nextjs-icon.6cb0977e.svg","height":48,"width":48,"blurWidth":0,"blurHeight":0};